const formatter = new Intl.NumberFormat('es-ES', {
  useGrouping: true,
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
});

// Presentation only: API numbers keep their original precision for calculations.
export function formatPreferenceNumber(value, { percentRatio = false } = {}) {
  if (typeof value !== 'number' &&
      (typeof value !== 'string' || !/^[+-]?(?:\d+\.?\d*|\.\d+)(?:e[+-]?\d+)?$/i.test(value.trim()))) return '-';
  const number = Number(value) * (percentRatio ? 100 : 1);
  if (!Number.isFinite(number)) return '-';
  // es-ES normally omits grouping for four-digit integers; group those too.
  return formatter.formatToParts(number).map(part => part.type === 'integer'
    ? part.value.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    : part.value).join('');
}

// Platinum score: the API ratio (0..1) as whole points; '-' when the ticker has none.
export function formatPlatinumScore(value) {
  const formatted = formatPreferenceNumber(value);
  return formatted === '-' ? formatted : String(Math.round(Number(value) * 100));
}

// Values the API still fills in for a ticker without entry (SE): zeros, and
// 9999 as the entry distance. None of them is real data.
const ENTRY_FIELDS = ['instrument_number', 'real_entry', 'amount', 'entry_distance', 'entrada_seg', 'risk_reward', 'resistance'];

export function hasNoEntry(ticker) {
  return Boolean(ticker) && (ticker.entry_type_name === 'SE' || ticker._type === 'StockAnalysisSE');
}

// One bar value of the selected ticker: '-' (without unit) when it is absent
// or the ticker has no entry to derive it from.
export function formatTickerPreference(ticker, field, { suffix = '', percentRatio = false } = {}) {
  if (!ticker || (ENTRY_FIELDS.includes(field) && hasNoEntry(ticker))) return '-';
  const formatted = formatPreferenceNumber(ticker[field], { percentRatio });
  return formatted === '-' ? formatted : formatted + suffix;
}

// For views with their own number format: `format` only runs when the ticker
// has an entry, so it never formats a placeholder.
export function entryValueOrDash(ticker, format) {
  return hasNoEntry(ticker) ? '-' : format();
}
